/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SigninRouteImport } from "./routes/signin"
import { Route as SetupRouteImport } from "./routes/setup"
import { Route as AdminRouteImport } from "./routes/admin"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AgentsIndexRouteImport } from "./routes/agents.index"
import { Route as StoryStoryIdRouteImport } from "./routes/story/$storyId"
import { Route as AgentsAuthorizeRouteImport } from "./routes/agents.authorize"

const SigninRoute = SigninRouteImport.update({
  id: "/signin",
  path: "/signin",
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: "/setup",
  path: "/setup",
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: "/agents/",
  path: "/agents/",
  getParentRoute: () => rootRouteImport,
} as any)
const StoryStoryIdRoute = StoryStoryIdRouteImport.update({
  id: "/story/$storyId",
  path: "/story/$storyId",
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAuthorizeRoute = AgentsAuthorizeRouteImport.update({
  id: "/agents/authorize",
  path: "/agents/authorize",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/setup": typeof SetupRoute
  "/signin": typeof SigninRoute
  "/agents/authorize": typeof AgentsAuthorizeRoute
  "/story/$storyId": typeof StoryStoryIdRoute
  "/agents": typeof AgentsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/setup": typeof SetupRoute
  "/signin": typeof SigninRoute
  "/agents/authorize": typeof AgentsAuthorizeRoute
  "/story/$storyId": typeof StoryStoryIdRoute
  "/agents": typeof AgentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/admin": typeof AdminRoute
  "/setup": typeof SetupRoute
  "/signin": typeof SigninRoute
  "/agents/authorize": typeof AgentsAuthorizeRoute
  "/story/$storyId": typeof StoryStoryIdRoute
  "/agents/": typeof AgentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/admin"
    | "/setup"
    | "/signin"
    | "/agents/authorize"
    | "/story/$storyId"
    | "/agents"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/admin"
    | "/setup"
    | "/signin"
    | "/agents/authorize"
    | "/story/$storyId"
    | "/agents"
  id:
    | "__root__"
    | "/"
    | "/admin"
    | "/setup"
    | "/signin"
    | "/agents/authorize"
    | "/story/$storyId"
    | "/agents/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  SetupRoute: typeof SetupRoute
  SigninRoute: typeof SigninRoute
  AgentsAuthorizeRoute: typeof AgentsAuthorizeRoute
  StoryStoryIdRoute: typeof StoryStoryIdRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/signin": {
      id: "/signin"
      path: "/signin"
      fullPath: "/signin"
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/setup": {
      id: "/setup"
      path: "/setup"
      fullPath: "/setup"
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/admin": {
      id: "/admin"
      path: "/admin"
      fullPath: "/admin"
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/agents/": {
      id: "/agents/"
      path: "/agents"
      fullPath: "/agents"
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/story/$storyId": {
      id: "/story/$storyId"
      path: "/story/$storyId"
      fullPath: "/story/$storyId"
      preLoaderRoute: typeof StoryStoryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/agents/authorize": {
      id: "/agents/authorize"
      path: "/agents/authorize"
      fullPath: "/agents/authorize"
      preLoaderRoute: typeof AgentsAuthorizeRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  SetupRoute: SetupRoute,
  SigninRoute: SigninRoute,
  AgentsAuthorizeRoute: AgentsAuthorizeRoute,
  StoryStoryIdRoute: StoryStoryIdRoute,
  AgentsIndexRoute: AgentsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
